import { Action, ActionReducer, MetaReducer } from '@ngrx/store';
import { ROOT_ACTIONS } from './root.actions';
import { IRootState } from './root.state';

export const rootMetaReducers: MetaReducer<IRootState>[] = [persistStateReducer, clearStateReducer];

export function persistStateReducer(reducer: ActionReducer<IRootState>) {
  const storageKey: string = 'calsale';

  // console.log(`persist meta reduicer outer fn`);

  return (state: IRootState | undefined, action: Action) => {
    // console.group('metareducer');
    // console.log(`action: ${action.type}`)

    // on state initialization the state is undefined, we want to retrieve the state from local storage now
    if (state === undefined) {
      const persisted = sessionStorage.getItem(storageKey);
      // if we got something from local storage - return it, otherwise - use the reducer to instantiate the state
      return persisted ? JSON.parse(persisted) : reducer(state, action);
    }
    // on every action we call the "normal" reducer
    const newState = reducer(state, action);
    // update local storage with the new state
    sessionStorage.setItem(storageKey, JSON.stringify(newState));

    // console.groupEnd();

    return newState;
  };
}

export function clearStateReducer(reducer: any) {
  return function (state: IRootState | undefined, action: Action) {
    if (action.type === ROOT_ACTIONS.reset) {
      state = undefined;
    }

    const nextState = reducer(state, action);

    return nextState;
  };
}
